import React from 'react'

import { Carousel } from 'antd'

import classes from './index.module.scss'
import { getImagePath } from 'utils/imagePath'

type Props = {
  data: any[]
  setSelectedSlide: any
  autoplay?: boolean
}

export default function ACarousel({
  data,
  setSelectedSlide,
  autoplay = false
}: Props) {

  return (
    <Carousel
      beforeChange={(_, next) => setSelectedSlide(data[next])}
      dotPosition={`bottom`}
      draggable
      initialSlide={0}
      slidesPerRow={1}
      slidesToShow={1}
      className={`${classes.customSlick} ${data?.length === 1 ? classes.customTrack : ''} ${classes.carouselStyle}`}
      variableWidth={data?.length === 1}
      autoplay={autoplay}
      dots
      effect="fade"
      autoplaySpeed={3000}
    >
      {data?.map((d) => (
        <div
          className={classes.contentStyleContainer}
          key={d?.id}
        >
          <img
            src={getImagePath(d?.imagePath)}
            alt="g1"
            className={classes.contentStyle}
          />
        </div>
      ))}
    </Carousel>
  )
}
